export const SUBSCRIPTION_DISABLED = Boolean(
  process.env.GATSBY_SUBSCRIPTION_DISABLED
)

export const SUBSCRIPTION_STEP_SELECT_PLAN = 0
export const SUBSCRIPTION_STEP_CUSTOMER_PROFILE = 1
export const SUBSCRIPTION_STEP_PAYMENT = 2
export const SUBSCRIPTION_STEP_COMPLETE = 3
